export type GoogleRecommendedEventName =
  | 'add_payment_info'
  | 'begin_checkout'
  | 'login'
  | 'purchase'
  | 'refund'
  | 'select_item'
  | 'sign_up'
  | 'view_item_list'

export type AnalyticsVendorEventDefinition = {
  googleRecommendedEvent: GoogleRecommendedEventName | null
  googleKeyEvent: boolean
}

export const ANALYTICS_VENDOR_EVENT_MANIFEST = {
  account_created: {
    googleRecommendedEvent: 'sign_up',
    googleKeyEvent: true,
  },
  sign_in_completed: {
    googleRecommendedEvent: 'login',
    googleKeyEvent: false,
  },
  pricing_viewed: {
    googleRecommendedEvent: 'view_item_list',
    googleKeyEvent: false,
  },
  pricing_plan_selected: {
    googleRecommendedEvent: 'select_item',
    googleKeyEvent: false,
  },
  checkout_started: {
    googleRecommendedEvent: 'begin_checkout',
    googleKeyEvent: true,
  },
  checkout_payment_submitted: {
    googleRecommendedEvent: 'add_payment_info',
    googleKeyEvent: false,
  },
  payment_succeeded: {
    googleRecommendedEvent: 'purchase',
    googleKeyEvent: true,
  },
  renewal_succeeded: {
    googleRecommendedEvent: 'purchase',
    googleKeyEvent: false,
  },
  refund_succeeded: {
    googleRecommendedEvent: 'refund',
    googleKeyEvent: true,
  },
  grounded_answer_completed: {
    googleRecommendedEvent: null,
    googleKeyEvent: true,
  },
  organization_invitation_accepted: {
    googleRecommendedEvent: null,
    googleKeyEvent: true,
  },
  subscription_activated: {
    googleRecommendedEvent: null,
    googleKeyEvent: true,
  },
  subscription_reactivated: {
    googleRecommendedEvent: null,
    googleKeyEvent: true,
  },
} as const satisfies Record<string, AnalyticsVendorEventDefinition>

export const GOOGLE_KEY_EVENTS = [
  'sign_up',
  'grounded_answer_completed',
  'organization_invitation_accepted',
  'begin_checkout',
  'purchase',
  'subscription_activated',
  'subscription_reactivated',
  'refund',
] as const

export function getGoogleRecommendedEventName(eventName: string) {
  const definitions: Record<
    string,
    AnalyticsVendorEventDefinition | undefined
  > = ANALYTICS_VENDOR_EVENT_MANIFEST
  return definitions[eventName]?.googleRecommendedEvent ?? null
}
